import { render, staticRenderFns } from "./formPenilaian.vue?vue&type=template&id=c004d4f4&scoped=true&"
import script from "./formPenilaian.vue?vue&type=script&lang=js&"
export * from "./formPenilaian.vue?vue&type=script&lang=js&"
import style0 from "./formPenilaian.vue?vue&type=style&index=0&id=c004d4f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c004d4f4",
  null
  
)

export default component.exports